import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessageDetailRoutingModule } from './message-detail-routing.module';
import { MessageDetailComponent } from './pages/message-detail/message-detail.component';
import { HeaderMessageDetailComponent } from './components/header-message-detail/header-message-detail.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { SkeletonMessageDetailComponent } from './components/skeleton-message-detail/skeleton-message-detail.component';

@NgModule({
    declarations: [
        MessageDetailComponent,
        HeaderMessageDetailComponent,
        SkeletonMessageDetailComponent,
    ],
    imports: [
        CommonModule,
        MessageDetailRoutingModule,
        IonicModule,
        SharedModule,
    ],
    exports: [
        SkeletonMessageDetailComponent
    ]
})
export class MessageDetailModule {}
